import { createRoot } from "react-dom/client";
import Router from "./router";

const container = document.getElementById("app");
const root = createRoot(container)
root.render(<Router />);